import apiClient from './apiClient';
import type { AnalysisType } from '@corner/shared';
import { ANALYSIS_TYPES } from '@corner/shared';

export const api = {
  /** Export analysis text as PDF or Word doc — triggers browser download. */
  exportText: async (
    text: string,
    format: 'pdf' | 'docx',
    fileName = 'export',
  ): Promise<void> => {
    const res = await apiClient.post('/api/export-text', { text, format, fileName }, {
      responseType: 'blob',
    });
    const ext = format === 'docx' ? '.docx' : '.pdf';
    const blob = new Blob([res.data]);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName.replace(/\.[^.]+$/, '') + ext;
    a.click();
    URL.revokeObjectURL(url);
  },

  /** Tier 2 analysis: document → Claude prompt → text response (no file). */
  analyzeDocument: (
    file: File,
    analysisType: string,
  ): Promise<{ success: boolean; analysisType: string; result: string; exportable: boolean }> => {
    if (!ANALYSIS_TYPES.includes(analysisType as AnalysisType)) {
      return Promise.reject(new Error(`Invalid analysisType: ${analysisType}`));
    }
    const fd = new FormData();
    fd.append('files', file);
    fd.append('analysisType', analysisType);
    return apiClient
      .post<{ success: boolean; analysisType: string; result: string; exportable: boolean }>(
        '/api/analyze',
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      .then((r) => r.data);
  },
};
